/**
 * @file Comportement d'arme 'shotgun' : Fusil a pompe : weapon.pellets plombs repartis uniformement dans params.shotgunConeDeg, courte portee.
 */
import type { EntityId } from '@shared/types';
import type { SimContext } from '../../Context';
import { applyDamage, rollCrit } from '../../combat/damage';
import type { With } from '../../ecs/World';
import { DEG } from '../../math/geometry';
import { spawnProjectile } from '../projectiles';
import type { HitOutcome, ShotContext, WeaponBehaviorModule } from '../WeaponBehavior';
import { announceShot } from './common';

/** fire : plombs reparti dans le cone (+ petit bruit), critique tire PAR plomb, un seul evenement de tir. */
export const shotgunBehavior: WeaponBehaviorModule = {
  id: 'shotgun',
  fire(ctx: SimContext, shot: ShotContext): void {
    const { weapon: w, cat } = shot;
    const p = w.params;
    const n = Math.max(1, w.pellets);
    const ids: EntityId[] = [];
    for (let i = 0; i < n; i++) {
      const base = n === 1 ? shot.aimAngle : shot.aimAngle + (i / (n - 1) - 0.5) * p.shotgunConeDeg * DEG;
      const angle = base + ctx.rng.combat.range(-2, 2) * DEG;
      const roll = rollCrit(ctx, w, w.damage);
      const proj = spawnProjectile(ctx, {
        kind: 'pellet',
        behavior: 'shotgun',
        ownerId: cat.id,
        weaponDefId: w.def.id,
        slot: w.slot,
        x: shot.originX,
        y: shot.originY,
        angle,
        speed: p.projectileSpeed,
        radius: p.projectileRadius,
        range: w.range,
        damage: roll.damage,
        crit: roll.crit,
        pierce: 0,
      });
      ids.push(proj.id);
    }
    announceShot(ctx, shot, 'shotgun', ids);
  },
  onHit(ctx: SimContext, proj: With<'projectile'>, target: With<'target' | 'health'>): HitOutcome {
    applyDamage(ctx, target, proj.projectile.damage, proj.projectile.crit, 'shotgun', proj.transform.x, proj.transform.y);
    return { consumed: true };
  },
};
